export default "__VITE_ASSET__Cwe1sLfJ__"